const footerRo = {
    "follow_us": "Urmați-ne!",
    "all_rights_reserved": "2024 Code Kitchen Kft. Toate drepturile rezervate.",
    "terms_and_conditions": "Termeni și condiții",
    "privacy_policy": "Politica de confidențialitate"
};

export default footerRo;
